import { AppNotification } from "../../features/insights/models/notifications";


export const notifications: AppNotification[] = [
  {
    id: 'blueocean-platform-000001',
    title: 'New: release notifications',
    summary: 'Become informed of upcoming releases with release notes on major and minor releases.',
    details: [
      'Introduced a centralized notification system on the Blue Ocean portal. Accessible through the notifications icon on the home page.',
      'Provides visibility into upcoming platform updates, feature changes and important events',
      'Historical view on releases keeps you informed of earlier released updates'
    ],
    tags: ['Platform'],
    availableTill: '2026-02-28T00:00:00Z',
    availableFrom: '2026-01-24T00:00:00Z',
    releaseDate: '2026-01-30T00:00:00Z'
  },
  {
    id: "compliancy-dashboard-1-11-0",
    title: "Compliancy - version 1.11.0",
    summary: "Simplifying the dashboard by focusing on Azure Secure Score, Microsoft Secure Score and regulatory compliance information.",
    details: [
      "Restyled homepage:\nWe have streamlined the homepage to provide a cleaner and more intuitive overview.\nThis optimization helps ensure the most relevant and actionable information is most visible.\n",
      "Improved Support for Optional Features:\nTo better serve different customer profiles, Compliancy now includes expanded feature‑flag capabilities.\nThis makes it easier to introduce new, targeted features that meet custom needs while keeping the experience consistent and relevant for all users.\n",
      "Simplifying the Compliance Overview:\nAs part of our ongoing commitment to using the most accurate and up‑to‑date sources, the Cegeka Compliancy Score has been retired from the interface.\nCustomers can continue to rely on Azure Secure Score as the authoritative metric for security posture.\n",
    ],
    tags: ["Compliancy", "Dashboard"],
    availableTill: "2026-03-17T00:00:00Z",
    availableFrom: "2026-02-02T00:00:00Z",
    releaseDate: "2026-02-17T00:00:00Z"
  },
  {
    id: 'infrastructure-dashboard-3-0-0',
    title: 'Infrastructure - version 3.0.0',
    summary: 'Improvements on security & protection, updates & patch management and backups views.',
    details: [
      'Security & Protection:\nMDE Status now based on vulnerability assessment results\nProtection status defaults to Defender endpoint protection. If not available, antimalware extension',
      'Updates & Patch management:\nMaintenance Configurations (Log Analytics) were replaced by Azure Update Schedules.\nMoved Updates from Log Analytics to Azure Update Manager\nReplaced Software Update configurations with Azure Update Manager Maintenance configurations',
      'Backups:\nVM Overview now has a clearer view on backup states.\nBackups page has been redesigned to better align with user feedback.',
    ],
    tags: ['Infrastructure', 'Dashboard'],
    availableTill: '2026-05-27T00:00:00Z',
    availableFrom: '2026-04-10T00:00:00Z',
    releaseDate: '2026-04-28T00:00:00Z'
  },
  {
    id: 'cost-dashboard-2-11-0',
    title: 'Cost - version 2.11.0',
    summary: 'Adjustments on reservation recommendations and cost details',
    details: [
      'Reservation recommendations:\nThe structure and visualization of the page has been updated to reflect user feedback and usage.\nEnhanced filter functionality between duration and type of reservations.',
      'Cost details:\nAdded functionality to filter view on purchases, refunds and usage.',
    ],
    tags: ['Cost', 'Dashboard'],
    availableTill: '2026-06-05T00:00:00Z',
    availableFrom: '2026-04-20T10:00:00Z',
    releaseDate: '2026-05-12T00:00:00Z'
  },
  {
    id: 'compliancy-dashboard-2-0-0',
    title: 'Compliancy - version 2.0.0',
    summary: 'New Policy Compliance tracking, Management Group filtering, and navigation improvements.',
    details: [
      'Policy Compliance:\nFull visibility into Azure Policy compliance across all resources\nTrack exemptions with expiry warnings\nPolicy compliance history and trend line now visible on the home page',
      'Management Groups:\nFilter all subscription level data by Management Group, up to 7 levels deep\nManagement Groups slicer available across all report pages',
      'Service Retirements:\nNow shows full details on upcoming retirements, going beyond the previous summary view',
      'Navigation:\nConsistent slicer pane now available across all report pages',
      'In case you are missing policies, it likely that we do not have permissions to the right scopes. The recommendation is to provide access to Tenant Root Group'
    ],
    tags: ['Compliancy', 'Dashboard'],
    availableTill: '2026-07-01T00:00:00Z',
    availableFrom: '2026-06-01T06:00:00Z',
    releaseDate: '2026-06-08T00:00:00Z'
  },
  {
    id: 'identity-dashboard-2-0-0',
    title: 'Identity - version 2.0.0',
    summary: 'Overview of applications and service principals, including ownership, credential health and API permissions, alongside Azure role assignments across all identities',
    details: [
      'Overview:\nOverview of identities by type and ownership\nCredential status across identities\nAzure role and API permission summaries\nVisibility into orphaned App Registrations',
      'Credentials:\nCredential health for App Registrations and Service Principals\nExpired and expiring credentials\nAffected identities and next credential expiry\nCredential status filtering',
      'Azure Roles:\nDirectory and Azure RBAC role assignments\nAssignments by role, identity type and role system\nBuilt-in and custom roles\nAssignment scope from tenant level down to individual resources',
      'API Permissions:\nApplication and delegated API permissions\nPermissions grouped by API and permission type\nApplications by permission count\nMost assigned permissions and APIs',
    ],
    tags: ['Identity', 'Dashboard'],
    availableTill: '2026-09-30T00:00:00Z',
    availableFrom: '2026-09-01T06:00:00Z',
    releaseDate: '2026-09-01T00:00:00Z'
  }


];
